module.exports = __webpack_public_path__ + "img/icon_nav_1_2.1188d25e.png";